import { css } from 'styled-components';
import { COLORS } from '../../design/tokens';

const styles = {
  container: css`
    padding-bottom: ${({ paddingBottom }) => paddingBottom} !important;
    padding-top: ${({ paddingTop }) => paddingTop} !important;
  `,
  sublabelContainer: css`
    padding-left: 34px;
  `,
  checkbox: css`
    display: flex !important;
    margin-left: 0px !important;

    & .ant-checkbox > .ant-checkbox-inner {
      height: 24px;
      width: 24px;
      border-radius: 0;
      border-width: 2px;
      border-color: ${COLORS.CHECKBOX.BASE.BORDER};
      ${props =>
        props.error
          ? css`
              border-color: #e0b4b4;
              color: #9f3a38;
              box-shadow: none;
              background-color: #fff6f6;
            `
          : ''}
    }

    .ant-checkbox-checked:hover::after,
     .ant-checkbox-checked::after{
      border: none;
    }

    & .ant-checkbox-checked > .ant-checkbox-inner {
      border-color: ${COLORS.CHECKBOX.CHECKED.BACKGROUND};
      background-color: transparent;
      &:after {
        margin-left: -1px;
        border-color: ${COLORS.CHECKBOX.CHECKED.BACKGROUND};
      }
    }

    & .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner,
    .ant-checkbox-input:focus + .ant-checkbox-inner {
      border-color: ${COLORS.CHECKBOX.BASE.BORDER};
    }

    & .ant-checkbox-inner {
      border-color: ${COLORS.CHECKBOX.FOCUS.BORDER};
    }

    & .ant-checkbox-input:focus + .ant-checkbox-inner {
      border-color: ${COLORS.CHECKBOX.FOCUS.BORDER};
    }

    & .ant-checkbox-inner::after {
      left: 7px;
      width: 6px;
      height: 10px;
    }

    &:hover span.ant-checkbox-inner {
      border-color: ${COLORS.CHECKBOX.HOVER.BORDER} !important;
    }
  `
};

export default styles;
